import { SortDescriptor } from '@progress/kendo-data-query';
import { SVGIcon } from '@progress/kendo-svg-icons';
import { ShoppingListProduct } from 'src/types/shopping_lists/ShoppingList';

export const SHOPPING_LIST_REORDER_MIME = 'application/x-shopping-list-reorder';

/** 6-dot grip icon shared by the reorder column and Guide Me. */
export const shoppingListDragIndicatorIcon: SVGIcon = {
  name: 'drag-indicator',
  content:
    '<path d="M8 9C8 10.1 7.1 11 6 11C4.9 11 4 10.1 4 9C4 7.9 4.9 7 6 7C7.1 7 8 7.9 8 9ZM14 9C14 10.1 13.1 11 12 11C10.9 11 10 10.1 10 9C10 7.9 10.9 7 12 7C13.1 7 14 7.9 14 9ZM20 9C20 10.1 19.1 11 18 11C16.9 11 16 10.1 16 9C16 7.9 16.9 7 18 7C19.1 7 20 7.9 20 9ZM8 15C8 16.1 7.1 17 6 17C4.9 17 4 16.1 4 15C4 13.9 4.9 13 6 13C7.1 13 8 13.9 8 15ZM14 15C14 16.1 13.1 17 12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15ZM20 15C20 16.1 19.1 17 18 17C16.9 17 16 16.1 16 15C16 13.9 16.9 13 18 13C19.1 13 20 13.9 20 15Z" />',
  viewBox: '0 0 24 24',
};

export const isSortOrderAscending = (sort: SortDescriptor[] | undefined): boolean =>
  Array.isArray(sort) &&
  sort.length === 1 &&
  sort[0]?.field === 'sortOrder' &&
  sort[0]?.dir === 'asc';

export const reorderShoppingListProducts = (
  products: ShoppingListProduct[],
  fromKey: string,
  toKey: string
): ShoppingListProduct[] => {
  if (!fromKey || !toKey || fromKey === toKey || products.length < 2) {
    return products;
  }

  const fromIndex = products.findIndex((product) => product.productKey === fromKey);
  const toIndex = products.findIndex((product) => product.productKey === toKey);

  if (fromIndex < 0 || toIndex < 0) {
    return products;
  }

  const next = [...products];
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);

  return next.map((product, index) => ({
    ...product,
    sortOrder: index + 1,
  }));
};
